"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _List = _interopRequireDefault(require("./List"));
var _excluded = ["listRef", "onFocusItem", "scrollBarPadding", "scrollMaxItems", "ScrollableContainer", "getScrollableContainerHeight", "getScrollableContainerScrollY", "setScrollableContainerScrollY", "calculateLayoutTrigger", "className", "children"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// `PureComponent` is only available in React >= 15.3.0.
var PureComponent = _react["default"].PureComponent || _react["default"].Component;
var ScrollableList_ = /*#__PURE__*/function (_PureComponent) {
  _inherits(ScrollableList_, _PureComponent);
  var _super = _createSuper(ScrollableList_);
  function ScrollableList_() {
    var _this;
    _classCallCheck(this, ScrollableList_);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    // Proxy `<List/>` methods.
    _defineProperty(_assertThisInitialized(_this), "focusItem", function (index) {
      return _this.list.focusItem(index);
    });
    _defineProperty(_assertThisInitialized(_this), "focus", function () {
      return _this.list.focus();
    });
    _defineProperty(_assertThisInitialized(_this), "clearFocus", function () {
      return _this.list.clearFocus();
    });
    _defineProperty(_assertThisInitialized(_this), "onListItemsChanged", function () {
      return _this.list.onListItemsChanged();
    });
    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event) {
      return _this.list.onKeyDown(event);
    });
    _defineProperty(_assertThisInitialized(_this), "chooseFocusedItem", function () {
      return _this.list.chooseFocusedItem();
    });
    _defineProperty(_assertThisInitialized(_this), "getFocusedItemIndex", function () {
      return _this.list.getFocusedItemIndex();
    });
    _defineProperty(_assertThisInitialized(_this), "focusItem", function (index) {
      return _this.list.focusItem(index);
    });
    // Re-calculates `<ScrollableList/>` `height`/`maxHeight`/`verticalPadding`.
    _defineProperty(_assertThisInitialized(_this), "state", {});
    _defineProperty(_assertThisInitialized(_this), "onExpand", function () {
      _this.setState({
        calculateLayoutTrigger: {}
      });
    });
    _defineProperty(_assertThisInitialized(_this), "storeListRef", function (ref) {
      return _this.list = ref;
    });
    return _this;
  }
  _createClass(ScrollableList_, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(ScrollableList, _extends({
        listRef: this.storeListRef,
        calculateLayoutTrigger: this.state.calculateLayoutTrigger
      }, this.props));
    }
  }]);
  return ScrollableList_;
}(PureComponent);
exports["default"] = ScrollableList_;
var ScrollableList = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var listRef = _ref.listRef,
    onFocusItem_ = _ref.onFocusItem,
    scrollBarPadding = _ref.scrollBarPadding,
    scrollMaxItems = _ref.scrollMaxItems,
    ScrollableContainer = _ref.ScrollableContainer,
    getScrollableContainerHeight = _ref.getScrollableContainerHeight,
    getScrollableContainerScrollY = _ref.getScrollableContainerScrollY,
    setScrollableContainerScrollY = _ref.setScrollableContainerScrollY,
    calculateLayoutTrigger = _ref.calculateLayoutTrigger,
    className = _ref.className,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var list = (0, _react.useRef)();
  var storeListRef = (0, _react.useCallback)(function (instance) {
    if (listRef) {
      if (typeof listRef === 'function') {
        listRef(instance);
      } else {
        listRef.current = instance;
      }
    }
    list.current = instance;
  }, []);

  // Is initialized during the first `componentDidUpdate()` call.
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    verticalPadding = _useState2[0],
    setVerticalPadding = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    height = _useState4[0],
    setHeight = _useState4[1];
  var _useState5 = (0, _react.useState)(),
    _useState6 = _slicedToArray(_useState5, 2),
    maxHeight = _useState6[0],
    setMaxHeight = _useState6[1];
  var getListNode = (0, _react.useCallback)(function () {
    return list.current.list;
  }, []);
  var scrollableContainer = (0, _react.useRef)();
  var getListHeight = (0, _react.useCallback)(function () {
    if (getScrollableContainerHeight) {
      return getScrollableContainerHeight(scrollableContainer.current);
    } else {
      return getListNode().offsetHeight;
    }
  }, [getScrollableContainerHeight, getListNode]);
  var getListScrollY = (0, _react.useCallback)(function () {
    if (getScrollableContainerScrollY) {
      return getScrollableContainerScrollY(scrollableContainer.current);
    } else {
      return getListNode().scrollTop;
    }
  }, [getScrollableContainerScrollY, getListNode]);
  var setListScrollY = (0, _react.useCallback)(function (scrollY) {
    if (setScrollableContainerScrollY) {
      setScrollableContainerScrollY(scrollableContainer.current, scrollY);
    } else {
      getListNode().scrollTop = scrollY;
    }
  }, [setScrollableContainerScrollY, getListNode]);
  var showElement = (0, _react.useCallback)(function (itemElement, _ref2) {
    var isFirstItem = _ref2.isFirstItem,
      isLastItem = _ref2.isLastItem;
    var topEdge = itemElement.offsetTop;
    var bottomEdge = itemElement.offsetTop + itemElement.offsetHeight;
    if (isFirstItem) {
      topEdge -= verticalPadding;
    }
    if (isLastItem) {
      bottomEdge += verticalPadding;
    }
    var listScrollY = getListScrollY();
    var listHeight = getListHeight();

    // Show the top edge if it's hidden.
    if (topEdge < listScrollY) {
      setListScrollY(topEdge);
    }

    // Show the bottom edge if it's hidden.
    if (bottomEdge > listScrollY + listHeight) {
      setListScrollY(bottomEdge - listHeight);
    }
  }, [verticalPadding, getListNode, getListHeight]);

  // Fully shows an option having the `value` (scrolls to it if neccessary)
  var showItem = (0, _react.useCallback)(function (index) {
    showElement(list.current.itemRefs[index], {
      isFirstItem: index === 0,
      isLastItem: index === _react["default"].Children.count(children) - 1
    });
  }, [showElement, children]);
  var onFocusItem = (0, _react.useCallback)(function (index, options) {
    if (onFocusItem_) {
      onFocusItem_(index, options);
    }
    // When `<List/>` calls `.focusItem()` in `componentDidMount()`
    // `list.current` doesn't exist yet, hence the check.
    if (index !== undefined && list.current) {
      showItem(index);
    }
  }, [onFocusItem_, showItem]);
  var isOverflown = function isOverflown() {
    return scrollMaxItems > 0 && _react["default"].Children.count(children) > scrollMaxItems;
  };
  var calculateScrollableListHeight = function calculateScrollableListHeight(height, verticalPadding) {
    // Adding vertical padding here so that it shows `scrollMaxItems` items fully.
    // Also gives a peek on the `scrollMaxItems + 1`th item by showing a half of it.
    // Assumes items having equal height.
    return (height - 2 * verticalPadding) * ((scrollMaxItems + 0.5) / _react["default"].Children.count(children)) + verticalPadding;
  };

  // Calculates height of the item list.
  var calculateLayout = function calculateLayout() {
    var height = getListNode().scrollHeight;
    var verticalPadding = parseInt(window.getComputedStyle(getListNode()).paddingTop);

    // Calculate the appropriate list height.
    if (isOverflown()) {
      var _maxHeight = calculateScrollableListHeight(height, verticalPadding);
      if (!ScrollableContainer) {
        // Update `max-height` immediately, without waiting for the next React render cycle.
        list.current.getDOMNode().style.maxHeight = _maxHeight + 'px';
      }
      setMaxHeight(_maxHeight);
    }
    setHeight(height);
    setVerticalPadding(verticalPadding);
  };
  (0, _react.useLayoutEffect)(function () {
    calculateLayout();
  }, [calculateLayoutTrigger]);
  var maxHeightStyle = (0, _react.useMemo)(function () {
    if (maxHeight !== undefined) {
      // Makes the list scrollable if it's max height is constrained.
      return {
        maxHeight: "".concat(maxHeight, "px")
      };
    }
  }, [maxHeight]);
  var listElement = /*#__PURE__*/_react["default"].createElement(_List["default"], _extends({}, rest, {
    ref: storeListRef,
    onFocusItem: onFocusItem,
    style: ScrollableContainer ? undefined : maxHeightStyle,
    className: (0, _classnames["default"])(className, {
      'rrui__scrollable': ScrollableContainer ? undefined : isOverflown()
    })
  }), children);
  if (ScrollableContainer) {
    return /*#__PURE__*/_react["default"].createElement(ScrollableContainer, {
      ref: scrollableContainer,
      style: maxHeightStyle,
      maxHeight: maxHeight
    }, listElement);
  }
  return listElement;
});
ScrollableList.propTypes = {
  // // A list of items.
  // items : PropTypes.arrayOf
  // (
  // 	PropTypes.shape
  // 	({
  // 		// Item value (may be `undefined`).
  // 		value : PropTypes.any,
  // 		// Item label (may be `undefined`).
  // 		label : PropTypes.string,
  // 		// Item icon component.
  // 		icon  : PropTypes.func,
  // 		// Render custom content (a React component).
  // 		// Receives `{ value, label }` properties.
  // 		content : PropTypes.func
  // 	})
  // ),

  // Maximum items fitting the list height (scrollable).
  // Set to `0` to disable overflow.
  // Is `6` by default.
  scrollMaxItems: _propTypes["default"].number,
  // Whether should add `margin-right` for scrollbar width on overflow.
  // Is `true` by default.
  scrollBarPadding: _propTypes["default"].bool,
  ScrollableContainer: _propTypes["default"].elementType,
  getScrollableContainerHeight: _propTypes["default"].func,
  getScrollableContainerScrollY: _propTypes["default"].func,
  setScrollableContainerScrollY: _propTypes["default"].func,
  listRef: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),
  className: _propTypes["default"].string
};
ScrollableList.defaultProps = {
  scrollMaxItems: 6,
  scrollBarPadding: true
};
//# sourceMappingURL=ScrollableList.js.map